import { render } from "./BaseBadge.vue?vue&type=template&id=7b8186e2&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=7b8186e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b8186e2"

export default script